import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useFetch, usePromise } from '@rad/hooks';
import { useNotify } from '@rad/contexts/notifications';
import { staticForm, adjustForm, formValues, unsafeMapForm, formWithErrors } from '@rad/components/dynamic-form/common';
import { getUser, createUser, updateUser } from '../types';
import LayoutForm from '../layouts/form';
const constructForm = () => staticForm([
    [
        {
            'id': 'email',
            'title': 'Email',
            'kind': 'text',
            'value': '',
            'settings': {
                'special': 'plain',
            },
            'required': true,
        },
        {
            'id': 'firstname',
            'title': 'First Name',
            'kind': 'text',
            'value': '',
            'settings': {
                'special': 'plain',
            },
            'required': true,
        },
        {
            'id': 'lastname',
            'title': 'Last Name',
            'kind': 'text',
            'value': '',
            'settings': {
                'special': 'plain',
            },
            'required': true,
        },
    ],
    [
        {
            'id': 'admin',
            'title': 'Admin',
            'kind': 'checkbox',
            'value': false,
            'settings': {},
            'required': false,
        },
        {
            'id': 'superadmin',
            'title': 'Super Admin',
            'kind': 'checkbox',
            'value': false,
            'settings': {},
            'required': false,
        },
    ],
]);
const logic = (_) => (x, values) => {
    switch (x.id) {
        case 'superadmin':
            return { ...x, 'value': values['admin'] && values['superadmin'], 'disabled': !values['admin'] };
        default:
            return x;
    }
};
const UserEdit = (props) => {
    const notify = useNotify();
    const [userPromise] = useFetch(getUser(props.id));
    const user = usePromise(userPromise);
    const [stateForm, setForm] = React.useState(constructForm());
    const adjustedForm = adjustForm(logic(undefined))(stateForm);
    const [stateErrors, setErrors] = React.useState(undefined);
    const submit = async (e) => {
        e.preventDefault();
        const [valid, result] = await updateUser({
            'id': props.id,
            ...formValues(stateForm),
        });
        if (valid) {
            notify({ 'kind': 'success', 'message': 'User updated successfully!' });
            window.location.hash = `#/admin/users`;
        }
        else {
            setErrors(result);
        }
    };
    React.useEffect(() => {
        setForm(unsafeMapForm(stateForm, (x) => {
            if (!!user) {
                switch (x.id) {
                    case 'email':
                        return { ...x, 'value': user.email };
                    case 'firstname':
                        return { ...x, 'value': user.firstname };
                    case 'lastname':
                        return { ...x, 'value': user.lastname };
                    case 'admin':
                        return { ...x, 'value': user.role === 'admin' || user.role === 'super-admin' };
                    case 'superadmin':
                        return { ...x, 'value': user.role === 'super-admin' };
                    default:
                        return x;
                }
            }
            else {
                return x;
            }
        }));
    }, [user]);
    if (user === undefined) {
        return _jsx(_Fragment, { children: "Loading..." });
    }
    else if (user === null) {
        return _jsx(_Fragment, { children: "Not Found" });
    }
    else {
        return _jsx(LayoutForm, { title: "Edit User", form: formWithErrors(adjustedForm, stateErrors), onChange: setForm, onSubmit: submit });
    }
};
const UserNew = (props) => {
    const notify = useNotify();
    const [stateForm, setForm] = React.useState(constructForm());
    const adjustedForm = adjustForm(logic(undefined))(stateForm);
    const [stateErrors, setErrors] = React.useState(undefined);
    const submit = async (e) => {
        e.preventDefault();
        const [valid, result] = await createUser({
            ...formValues(stateForm),
        });
        if (valid) {
            notify({ 'kind': 'success', 'message': 'User added successfully!' });
            window.location.hash = `#/admin/users`;
        }
        else {
            setErrors(result);
        }
    };
    return _jsx(LayoutForm, { toolbarRight: _jsx(_Fragment, {}), title: "Add Measure to Scorecard", form: formWithErrors(adjustedForm, stateErrors), onChange: setForm, onSubmit: submit });
};
export const UserScreen = (props) => {
    return props.id ? _jsx(UserEdit, { id: props.id }) : _jsx(UserNew, {});
};
export default UserScreen;
